import React from 'react';
import Modal from '../common/Modal';
import Button from '../common/Button';

interface PodiumWelcomeModalProps {
  isOpen: boolean;
  onClose: () => void;
}

const PodiumWelcomeModal: React.FC<PodiumWelcomeModalProps> = ({ isOpen, onClose }) => {
  return (
    <Modal isOpen={isOpen} onClose={onClose} size="md" showCloseButton={false}>
      <div className="p-6 sm:p-8">
        {/* Logo / Brand */}
        <div className="text-center mb-6">
          <h2 className="text-2xl sm:text-3xl font-bold text-gray-900 dark:text-white mb-2">
            Welcome to Alpha Air
          </h2>
          <p className="text-gray-600 dark:text-gray-300 text-sm sm:text-base">
            Melbourne's trusted heating &amp; cooling specialists
          </p>
        </div>

        {/* What this app does */}
        <div className="bg-blue-50 dark:bg-blue-900/20 rounded-lg p-4 sm:p-5 mb-6">
          <p className="text-gray-700 dark:text-gray-200 text-sm sm:text-base leading-relaxed">
            Use this portal to <strong>book an onsite quote, service job, or warranty appointment</strong> with Alpha Air.
            It only takes a few minutes — here's how it works:
          </p>
        </div>

        {/* 3-Step Process */}
        <div className="space-y-4 mb-8">
          <div className="flex items-start gap-3">
            <div className="w-8 h-8 bg-primary text-white rounded-full flex items-center justify-center text-sm font-bold flex-shrink-0 mt-0.5">
              1
            </div>
            <div>
              <p className="font-semibold text-gray-900 dark:text-white text-sm sm:text-base">Enter your details</p>
              <p className="text-gray-500 dark:text-gray-400 text-xs sm:text-sm">Name, contact info, and property address</p>
            </div>
          </div>
          <div className="flex items-start gap-3">
            <div className="w-8 h-8 bg-gray-300 dark:bg-gray-600 text-gray-700 dark:text-gray-300 rounded-full flex items-center justify-center text-sm font-bold flex-shrink-0 mt-0.5">
              2
            </div>
            <div>
              <p className="font-semibold text-gray-900 dark:text-white text-sm sm:text-base">Tell us about the job</p>
              <p className="text-gray-500 dark:text-gray-400 text-xs sm:text-sm">Service type, number of units, and any photos</p>
            </div>
          </div>
          <div className="flex items-start gap-3">
            <div className="w-8 h-8 bg-gray-300 dark:bg-gray-600 text-gray-700 dark:text-gray-300 rounded-full flex items-center justify-center text-sm font-bold flex-shrink-0 mt-0.5">
              3
            </div>
            <div>
              <p className="font-semibold text-gray-900 dark:text-white text-sm sm:text-base">Pick a time</p>
              <p className="text-gray-500 dark:text-gray-400 text-xs sm:text-sm">Choose a date and time that suits you</p>
            </div>
          </div>
        </div>

        {/* CTA */}
        <Button
          onClick={onClose}
          className="w-full"
          size="lg"
        >
          Get Started
        </Button>
      </div>
    </Modal>
  );
};

export default PodiumWelcomeModal;
